import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Blogals = makeShortcode("Blogals");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Provides the instructions to install and setup OpenShift CRC for use with the `}<Globals name="shortName" mdxType="Globals" />{`.`}</p>
    </PageDescription>
    <p>{`The `}<Globals name="longName" mdxType="Globals" />{` facilitate development and deployment of cloud-native applications.
They can be hosted in any Kubernetes or OpenShift cluster, including the Red Hat CodeReady Containers local
OpenShift environment.`}</p>
    <p>{`These instructions help you install Red Hat CodeReady Containers and explain
how to configure and run the Terraform infrastructure-as-code (IasC) scripts to install the Developer Tools into
that CodeReady Containers install.`}</p>
    <h2>{`Prerequisites`}</h2>
    <p>{`The following prerequisites are required to support installing CodeReady Containers:`}</p>
    <ul>
      <li parentName="ul">{`CodeReady Containers `}<a parentName="li" {...{
          "href": "https://access.redhat.com/documentation/en-us/red_hat_codeready_containers/1.0/html/getting_started_guide/getting-started-with-codeready-containers_gsg#minimum-system-requirements_gsg"
        }}>{`Minimum system requirements`}</a></li>
      <li parentName="ul">{`A `}<a parentName="li" {...{
          "href": "https://access.redhat.com/login"
        }}>{`Red Hat account`}</a>{` is required`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/dev-guide/getting-started/prereqs"
        }}><Blogals name="shortName" mdxType="Blogals" />{` prerequisites`}</a></li>
    </ul>
    <h2>{`Install the CRC binary`}</h2>
    <p>{`Install and configure CRC as described in `}<a parentName="p" {...{
        "href": "https://cloud.redhat.com/openshift/install/crc/installer-provisioned"
      }}>{`Install on Laptop`}</a></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Remember to download the `}<strong parentName="p">{`Pull Secret`}</strong>{` file`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`CRC executable`}</strong>{`: Copy the crc binary to your $PATH:`}</p>
        <p parentName="li">{`  From the directory where you unzipped the download:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`cp crc /usr/local/bin
`}</code></pre>
      </li>
    </ul>
    <h2>{`Configure the CRC instance`}</h2>
    <p>{`Follow these steps to complete the installation:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Setup`}</strong>{`: Run the following command from a terminal session:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`crc setup
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Add memory`}</strong>{`: By default, the CRC VM is set to only use 8 GB of RAM. The more RAM you can give it, the better.`}</p>
        <p parentName="li">{`  To set the CRC VM to 10 GB of RAM, do this:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`crc config set memory 10240
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Start`}</strong>{` the local CRC Cluster`}</p>
        <p parentName="li">{`  Run the crc start command in a terminal window:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`crc start -p {pull-secret-file}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Wait about 5 minutes for the VM initialization to complete. When complete, the kubeadmin password will be displayed. Make note of
this password because you will need it to log into the console.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open the Cluster Admin `}<strong parentName="p">{`Console`}</strong></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`crc console
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open a web browser and go to the OpenShift console`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Login with user id `}<strong parentName="p">{`kubeadmin`}</strong>{` and the password that was displayed
after the `}<inlineCode parentName="p">{`crc start`}</inlineCode>{` had completed.`}</p>
      </li>
    </ul>
    <p>{`Other useful links:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://access.redhat.com/documentation/en-us/red_hat_codeready_containers/1.0/html/getting_started_guide/getting-started-with-codeready-containers_gsg"
        }}>{`Getting started with Red Hat CodeReady Containers, Section 1.5`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://access.redhat.com/documentation/en-us/red_hat_codeready_containers/1.0/html/getting_started_guide/getting-started-with-codeready-containers_gsg#installing-codeready-containers_gsg"
        }}>{`Installing CodeReady Containers`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      